module.exports = __webpack_public_path__ + "img/9.54bd6692.png";